export default __webpack_public_path__ + "static/media/geplog.4cb15cb1.png";